import { ICellRendererParams } from 'ag-grid-community';
import { ReactNode } from 'react';

import { TooltipPosition } from 'theme/enums';
import { IColorMap } from 'theme/types';

import Status from './Status';
import Tooltip from './Tooltip';

interface IProps extends ICellRendererParams {
  colorMap: IColorMap;
  labelMap?: Record<string, string>;
  // Row-level tooltip (e.g. why an order failed). Group rows have no data and get none.
  getTooltip?: (data: unknown) => ReactNode | null;
}

const StatusCell = ({ value, data, colorMap, labelMap = null, getTooltip = null }: IProps) => {
  if (!value) {
    return null;
  }

  const status = <Status value={value} colorMap={colorMap} labelMap={labelMap} />;
  const tooltip = data && getTooltip ? getTooltip(data) : null;

  if (!tooltip) {
    return status;
  }

  return (
    <Tooltip
      title={tooltip}
      placement={TooltipPosition.TOP_START}
      sx={{ maxWidth: 420, whiteSpace: 'pre-wrap' }}
    >
      {status}
    </Tooltip>
  );
};

export default StatusCell;
